import { render, staticRenderFns } from "./include_age_group_table.vue?vue&type=template&id=2da304f7&scoped=true&"
import script from "./include_age_group_table.vue?vue&type=script&lang=js&"
export * from "./include_age_group_table.vue?vue&type=script&lang=js&"
import style0 from "./include_age_group_table.vue?vue&type=style&index=0&id=2da304f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da304f7",
  null
  
)

export default component.exports